<template>
  <PagesFellowsSlugComponent
    :pageData="data"
    :parentPageData="parentData"
  />
</template>

<script lang="ts" setup>
// 1
const queryPath = queryParticipantEntryBySlug(baseStrapiGetSlugQueryObjectFromRoute())
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPath } }
  )
})

if (!data?.value?.data?.length || error.value) {
  throw createError({
    statusCode: 500,
    statusMessage: 'Page not found',
    stack: ''
  })
}

pageSetHead(data)

// 2
const { data: parentData, error: parentError } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryParticipantsPageThumbnail() } }
  )
})
</script>
